import classNames from 'classnames'
import { TextField } from 'formik-mui'
import DeleteIcon from 'mdi-react/DeleteIcon'
import React from 'react'
import { MaterialFormikErrorMessage } from 'scenes/Dashboard/components/Inputs/MaterialFormikErrorMessage.component'
import { AutoCompleteDataType, AutoCompleteFormik } from 'scenes/Dashboard/components/Inputs/Select'
import { OrganizationType } from 'scenes/Dashboard/data/organizations/types'
import { connect, FastField, FormProps, getIn } from 'utils-next/forms'
import * as Yup from 'yup'

import { IconButton, Paper } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import { EducationFormValues } from '../../PersonForm.model'
import styles from './InlineForm.style'

class EducationForm extends React.PureComponent<EducationFormFullProps, EducationFormState> {
  constructor(props: EducationFormFullProps) {
    super(props)

    // TODO: Create a edition mode
    this.state = {
      isInEditMode: true,
    }

    this.handleDelete = this.handleDelete.bind(this)
    this.handleCreateSchool = this.handleCreateSchool.bind(this)
  }

  handleDelete() {
    const { education, onDelete, index } = this.props
    onDelete(education, index)
  }

  handleCreateSchool(inputValue: string) {
    return {
      value: {
        name: inputValue,
        domain: 'temp',
        types: [OrganizationType.school],
      },
      display: { label: inputValue },
    }
  }

  render() {
    const { classes, className, name, formik } = this.props
    const schoolValue = getIn(formik.values, `${name}.organization`)

    return (
      <Paper elevation={2} className={classNames(classes.formContainer, className)}>
        <div className={classes.fieldList}>
          <div className={classes.field}>
            <AutoCompleteFormik
              label="School"
              name={`${name}.organization`}
              dataType={AutoCompleteDataType.school}
              onCreateOption={this.handleCreateSchool}
              isValidNewOption={(inputValue: string) => !!inputValue}
              autoFocus={!schoolValue}
            />
            <MaterialFormikErrorMessage name={`${name}.organization`} />
          </div>
          <FastField
            component={TextField}
            label="Degree type"
            name={`${name}.degreeType`}
            className={classes.field}
            fullWidth
          />
          <FastField
            component={TextField}
            label="Degree subject"
            name={`${name}.degreeSubject`}
            className={classes.field}
            fullWidth
          />
          <FastField component={TextField} label="Grade" name={`${name}.grade`} className={classes.field} fullWidth />
          <div className={classes.dateWrapper}>
            <FastField
              component={TextField}
              label="Started on"
              name={`${name}.startedOn`}
              type="date"
              className={classes.field}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            />
            <FastField
              component={TextField}
              label="Ended on"
              name={`${name}.endedOn`}
              type="date"
              className={classes.field}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            />
          </div>
          <div className={classes.actions}>
            <IconButton aria-label="Delete education" onClick={this.handleDelete}>
              <DeleteIcon />
            </IconButton>
          </div>
        </div>
      </Paper>
    )
  }
}

export const educationValidationSchema = Yup.object().shape({
  organization: Yup.object()
    .shape({
      value: Yup.mixed(),
      display: Yup.mixed(),
    })
    .required('Organization is required')
    .typeError('Organization is required'),
  degreeType: Yup.string(),
  degreeSubject: Yup.string(),
  grade: Yup.string(),
  // startedOn: Yup.date().required('Variable startedOn is required'),
})

export type EducationFormFullProps = WithStyles<typeof styles> & {
  formik: FormProps<any>
} & EducationFormProps

type EducationFormProps = {
  className?: string
  name: string
  education: EducationFormValues
  index: number
  onDelete: (education: EducationFormValues, index: number) => void
}

type EducationFormState = {
  isInEditMode: boolean
}

export default withStyles(styles)(connect<EducationFormProps>(EducationForm as any))
